module.exports = __webpack_public_path__ + "b4b3c6891b04c78adbfa0c34c94fbbe4.pdf";